<ng-template #content let-modal>
  <div class="modal-header">
    <div class="col-md-12">
      <button class="btn pull-right" (click)="dismiss()">
        <i class="fa fa-times"></i>
      </button>
      <span>
        {{ app.text.part.createPart }}
      </span>
    </div>
  </div>
  <div class="modal-body">
    @if (warning) {
      <span class="warning">{{ warning }}</span>
    }
    <div class="col-md-12">
      @for (field of columns; track field; let index = $index) {
        <app-field
          [model]="model"
          [field]="field"
          [index]="index"
        ></app-field>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-cancel text-center m-1" (click)="dismiss()">
      {{ app.text.modal.cancel }}
    </button>
    <button
      class="btn btn-ok text-center m-1"
      (click)="save()"
      [disabled]="hasRequiredFields()"
      >
      {{ app.text.part.save }}
    </button>
  </div>
</ng-template>
